export default __webpack_public_path__ + "static/media/beavers-and-leader.86ed15f6.jpg";